import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextField";
import { ITagSchema } from "../../utils/validationSchema";
import ImageField from "../Reusable/ImageField";
import { RichTextEditor } from "../Reusable/RichTextEditor";

interface Props {
  register: UseFormRegister<ITagSchema>;
  setValue: UseFormSetValue<ITagSchema>;
  getValues: UseFormGetValues<ITagSchema>;
  errors: FieldErrors<ITagSchema>;
  clearErrors?: UseFormClearErrors<ITagSchema>;
  control: Control<ITagSchema>;
}

const TagForm = ({ register, errors, setValue, control }: Props) => {
  return (
    <div
      className={tw`grid grid-cols-2 gap-2`}
      style={{
        gridTemplateColumns: "1.3fr 2fr",
      }}
    >
      <div className={tw`px-2 border-r`}>
        <TextField
          placeholder="Enter a Category"
          type="text"
          label="Category Name"
          register={register("name", {
            required: "Name is required",
          })}
          errors={errors.name}
        />
        <ImageField
          label="Preview Image"
          control={control}
          name="preview_image"
        />
      </div>
      <RichTextEditor
        register={register("description")}
        setValue={setValue}
        errors={errors.description}
        label="Description"
        control={control}
        name="description"
      />
    </div>
  );
};

export default TagForm;
